import ReportsApi from '../../apis/Reports';

export default {
    namespaced: true,
    state: {
        operations: [],
        filters: null,
        till: null,
        detail: [],
        file_excel: null,
        paginated:{}
    },
    mutations: {
        set_operations (state, data) {
            state.operations = data;
        },
        set_filters (state, data) {
            state.filters = data;
        },
        set_till (state, data) {
            state.till = data;
        },
        set_detail(state, data) {
            state.detail = data;
        },
        set_file_excel (state, value) {
            state.file_excel = value;
        },
        set_paginated (state, data) {
            state.paginated =  data
        }
    },
    actions: {
        setFilters ({commit}, data) {
            commit('set_filters', data);
        },
        emptyReport({commit}) {
            commit('set_operations', []);
        },
        selectTill ({commit}, data) {
            commit('set_till', data);
        },
        async getTillsOperations({commit, dispatch}, filters) {
            commit('set_operations', []);
            return await ReportsApi.getTillsOperationsPaginated(filters)
                        .then( response => {
                            commit('set_paginated', {
                                ...response.data
                            })
                            commit('set_operations', response.data.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar historial de cajas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async getTillDetail({commit, dispatch}, filters) {
            commit('set_detail', []);
            return await ReportsApi.getTillDetail(filters)
                        .then( response => {
                            commit('set_detail', response.data);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al listar detalle cajas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async tillsExcel({commit, dispatch}, filters) {
            commit('set_file_excel', null);
            return await ReportsApi.tillsExcel(filters)
                        .then( response => {
                            commit('set_file_excel', response.data.file_excel);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar reporte de historial de cajas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async tillsDetailExcel({commit, dispatch}, filters) {
            commit('set_file_excel', null);
            return await ReportsApi.tillsDetailExcel(filters)
                        .then( response => {
                            commit('set_file_excel', response.data.file_excel);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar detalle de historial de cajas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
        async tillsDetailExcelNew({commit, dispatch}, filters) {
            commit('set_file_excel', null);
            return await ReportsApi.tillsDetailExcelNew(filters)
                        .then( response => {
                            commit('set_file_excel', response.data.file_excel);
                        })
                        .catch( error => {
                            if (error.response?.status === 401) return null
                            dispatch('notifications/store_notification', {
                                type: 'error',
                                message: 'Ocurrió un error al descargar detalle de historial de cajas, vuelva a intentarlo.'
                            }, {root: true});
                        })
        },
    }
}